import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Projects from "../Projects";
import ClassRoomDetails from "ClassRoom/routes/ClassRoomDetails";
export default store => ({
  path: "todos",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "toddle-academy" */ "./components"),
        import(
          /* webpackChunkName: "toddle-academy" */ "./modules/TodosModules"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1;
        injectReducer(store, {
          key: reducer.NAME,
          reducer: reducer.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Projects(store), ClassRoomDetails(store)],
});
